import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface SmartPhonePageProps extends BasePageProps {}

//------

type SmartState = {
    tipologiaApparecchio: string | undefined
    brand: string | undefined
    modello: string | undefined
    prezzo: string | undefined

    tipologiaApparecchioError?: string
    brandError?: string
    modelloError?: string
    prezzoError?: string

    dispositivi: any
    fasciaPrezzi: any
}

export type SmartPhonePageState = SmartState & BasePageState

export const smartPhonePageInitialState : SmartPhonePageState = {
    ...basePageInitialState,
    ...{
        tipologiaApparecchio: undefined,
        brand: undefined,
        modello: undefined,
        prezzo: undefined,
        tipologiaApparecchioError: undefined,
        brandError: undefined,
        modelloError: undefined,
        prezzoError: undefined,
        dispositivi: undefined,
        fasciaPrezzi: undefined,
    }
}

export const smartPhoneUpdate = createAction<SmartPhonePageState>('smartPhone/update')

export const smartPhoneReducer = createReducer ( 
    smartPhonePageInitialState,
    (builder) => {
        builder.addCase(smartPhoneUpdate, (state, action) => {
            return action.payload as SmartPhonePageState
        })
    }
)

export type SmartPhoneRootState = ReturnType<typeof store.getState>
export type SmartPhoneDispatch = typeof store.dispatch